module.exports = __webpack_public_path__ + "img/服務條款3.240cb72a.png";